import { cn } from '@shadcn/lib/utils';

export function AmbossIcon({ size = 20, className }: { size?: number; className?: string }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 21 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn('text-amboss-brand', className)}
      aria-hidden
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.6601 20.4299H4.17324L4.96236 18.9911H15.871L16.6601 20.4299ZM12.0739 6.0259L18.3962 17.5524H16.7298L12.0647 9.04724L11.2405 10.5492L15.0818 17.5524H5.75148L12.0739 6.0259ZM20.8332 18.9911L12.0646 3.00457L11.2499 4.52362L4.10349 17.5524H2.43711L11.2405 1.5021L10.4166 0L0 18.9911H3.31437L1.73613 21.8686H19.0972L17.5189 18.9911H20.8332Z"
        className="fill-current"
      />
    </svg>
  );
}
